import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../../store/configureStore';
import InvestmentUpdatesContainer from '../../containers/investor/investments/InvestmentUpdatesContainer';


const InvestorUpdates = props => (
  <Provider store={configureStore(props)}>
    <InvestmentUpdatesContainer />
  </Provider>
);

export default InvestorUpdates;
